import React from "react"
import { Row, Col, Button } from "reactstrap"
import Select from "react-select"
import { selectMenuStyles } from "../osHelpers"

// Barra de filtros da ListaOS (busca + status + condomínio + tipo + datas + Limpar).
// Componente controlado: o estado continua na ListaOS; aqui só renderizamos e
// devolvemos os valores via callbacks.
const FilterBarOS = ({
  searchTerm,
  onSearch,
  statusOptions,
  filterStatus,
  onStatus,
  condominioOptions,
  filterCondominio,
  onCondominio,
  tipoOptions,
  filterTipo,
  onTipo,
  filterDataInicio,
  onDataInicio,
  filterDataFim,
  onDataFim,
  onNovoTipo,
  onLimpar,
}) => (
  <>
    <Row className="gy-2">
      <Col xs={12} md={3}>
        <label className="form-label">Buscar</label>
        <input
          type="text"
          className="form-control"
          placeholder="Protocolo, condomínio, técnico..."
          value={searchTerm}
          onChange={e => onSearch(e.target.value)}
        />
      </Col>
      <Col xs={12} sm={6} md={2}>
        <label className="form-label">Status</label>
        <Select
          placeholder="Todos"
          options={statusOptions}
          value={statusOptions.find(o => o.value === filterStatus) || null}
          onChange={opt => onStatus(opt ? opt.value : "")}
          isClearable
          styles={selectMenuStyles}
        />
      </Col>
      <Col xs={12} sm={6} md={3}>
        <label className="form-label">Condomínio</label>
        <Select
          placeholder="Todos os condomínios"
          options={condominioOptions}
          value={
            condominioOptions.find(
              o => String(o.value) === String(filterCondominio),
            ) || null
          }
          onChange={opt => onCondominio(opt ? opt.value : "")}
          isClearable
          styles={selectMenuStyles}
        />
      </Col>
      <Col xs={12} sm={6} md={3}>
        <label className="form-label">Tipo de Serviço</label>
        <div className="d-flex gap-2">
          <div style={{ flex: 1 }}>
            <Select
              placeholder="Todos os tipos"
              options={tipoOptions}
              value={tipoOptions.find(o => o.value === filterTipo) || null}
              onChange={opt => onTipo(opt ? opt.value : "")}
              isClearable
              styles={selectMenuStyles}
            />
          </div>
          <Button
            color="primary"
            outline
            onClick={onNovoTipo}
            title="Cadastrar um novo tipo de serviço"
            className="text-nowrap"
          >
            <i className="bx bx-plus-circle me-1"></i>
            Novo tipo
          </Button>
        </div>
      </Col>
      <Col xs={12} md={1} className="d-flex align-items-end">
        <Button color="secondary" className="w-100" onClick={onLimpar}>
          <i className="bx bx-refresh me-1"></i>
          Limpar
        </Button>
      </Col>
    </Row>
    <Row className="gy-2 mt-1">
      <Col xs={12} sm={6} md={3}>
        <label className="form-label">Data início</label>
        <input
          type="date"
          className="form-control"
          value={filterDataInicio}
          onChange={e => onDataInicio(e.target.value)}
        />
      </Col>
      <Col xs={12} sm={6} md={3}>
        <label className="form-label">Data fim</label>
        <input
          type="date"
          className="form-control"
          value={filterDataFim}
          onChange={e => onDataFim(e.target.value)}
        />
      </Col>
    </Row>
  </>
)

export default FilterBarOS
